import React, { useState } from 'react'
import colorContext from '../../contexts/colorContext'
import { Colors, ThemedColors, AllColors } from '../../types/Colors'
import { colors as defaultColors, reversedColors, defaultThemedColors } from '../../theme/colors'
import { createGlobalStyle } from 'styled-components'

interface ColorVariablesProps {
  colors: AllColors
}
const ColorVariables = createGlobalStyle<ColorVariablesProps>`
    :root{
        ${({ colors }) => {
          let variables = ''
          ;(Object.keys(colors) as (keyof AllColors)[]).forEach((color) => {
            const shades = colors[color]
            Object.keys(shades).forEach((shade) => {
              variables += `--${color}-${shade}: ${shades[shade]}; \n`
            })
          })
          return variables
        }}
    }
`

const ColorProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [colors, setColors] = useState<Colors>(defaultColors)
  const [themedColors, setThemedColors] = useState<ThemedColors>(defaultThemedColors)
  const [isReversedColors, setIsReversedColors] = useState(false)

  const changeThemedColors = () => {}

  const reverseColors = () => {
    if (isReversedColors) setColors(defaultColors)
    else setColors(reversedColors)
  }

  window.reverseColors = reverseColors

  return (
    <colorContext.Provider value={{ changeThemedColors, reverseColors, isReversedColors, colors, themedColors }}>
      <ColorVariables colors={{ ...colors, ...themedColors }} />
      {children}
    </colorContext.Provider>
  )
}

export default ColorProvider
